import React from 'react'
import { withRouter } from 'react-router-dom'
import GlobalLoader from './../../components/global-loader/GlobalLoader'
import GlobalOverlay from './../../components/global-overlay/GlobalOverlay'
import Modal from './../../components/modal/Modal'
import RadioObjectGroup from './../../components/radio-object-group/RadioObjectGroup'
import { apiCallsCommercial } from './../../utils/apiCallsCommercial'
import { apiCallsResidential } from './../../utils/apiCallsResidential'
import { validateProjectOrBoardName } from './../../utils/helpers'
import commonFunctionsService from './../../services/CommonFunctionsService'
import Header from '../../components/header/Header'
import jQuery from 'jquery'
import cloneDeep from 'lodash.clonedeep'
import { getUrlParameter } from '../../utils/helpers'
import analyticsDataLayer from '../../services/AnalyticsDataLayer'

const { CONST } = require('../../CONST')

class Projects extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            isLoading: true,
            apiError: false,
            apiMessage: 'Loading user details',
            toBeApprovedCountCommercial: null,
            incompleteCountCommercial: null,
            completeCountCommercial: null,
            toBeApprovedCountResidential: null,
            incompleteCountResidential: null,
            completeCountResidential: null,
            isConsultant: false,
            landingPopupMessage: '',
            isCreatingNewProject: false,
            isLoadingNewProject: false,
            hasSubmittedNewProject: false,
            newProjectErrorMessage: '',
            hasCreatedNewProject: false,
            nameNewProject: '',
            searchValue: '',
            filterProjectTypeValue: 'all',
            sorthingType: '',
            ascendingSorting: false,
            anySearchResults: true,
            isLoadingOrders: true,
            isLandingPage: false,
            howItWorksModal: false,
            orders: [],
            isDuplicatingProject: false,
            confirmingProjectDeletion: false,
            projectToDelete: 0,
            isDeletingProject: false,
            hasDeletedProject: false,
            deletingProjectTitle: '',
            deletedProjectMessage: '',
            isCommercial: true,
            currentFlexType: 'Commercial',
            selectedProjectTypeForCreation: 'Commercial',
            isSwitchBoardManufacturerOrLargeContractor: false
        }
    }

    componentDidMount() {
        const seenPopupKey = 'longer-lead-times-popup-seen'
        if (!sessionStorage.getItem(seenPopupKey) && new Date() < Date.parse('2025-07-31')) {
            this.setState({
                landingPopupMessage: 'Due to the ongoing FlexSelect promotion, lead times may be slightly longer than usual. For urgent board requests, please contact your FlexSelect specialist.' })

            sessionStorage.setItem(seenPopupKey, 'seenMessage')
        }

        apiCallsCommercial.apiUserSettings()
            .then(response => {
                this.setState({
                    isConsultant: response.IsConsultant,
                    // Back-end uses constand to identify user roles, so this should be a reliable way to identifiy the role
                    isSwitchBoardManufacturerOrLargeContractor: response.UserType === 1 || response.UserType === 4
                })
            })

        this.updateProjectStats()
        this.getOrdersData()

        if (getUrlParameter('showResidential') === true) {
            this.setState({ isCommercial: false, currentFlexType: 'Residential' })
        }
    }

    updateProjectStats() {
        const commercialStats = apiCallsCommercial.apiActivityCount()
        const residentialStats = apiCallsResidential.apiActivityCount()

        Promise.allSettled([commercialStats, residentialStats])
            .then((results) => {
                this.setState({
                    isLoading: false,
                    completeCountCommercial: results[0].value.OrderCount,
                    incompleteCountCommercial: results[0].value.ProjectCount,
                    toBeApprovedCountCommercial: results[0].value.ToBeApprovedCount,
                    completeCountResidential: results[1].value.OrderCount,
                    incompleteCountResidential: results[1].value.ProjectCount,
                    toBeApprovedCountResidential: results[1].value.ToBeApprovedCount
                })
            })
    }

    getOrdersData() {
        this.setState({ isLoadingOrders: true })

        // Different flags for project API
        const requestObject = {
            IsArchived: false,
            IsDeleted: false,
            // IsFinalised: true
            // IsToBeApproved: true
        }

        let isLandingPage = window.localStorage.getItem('isLandingPage')

        const commercialProjects = apiCallsCommercial.apiAllProjects(requestObject)
        const residentialProjects = apiCallsResidential.apiAllProjects(requestObject)

        Promise.allSettled([commercialProjects, residentialProjects])
            .then((results) => {
                // We know that we have only 2 results and that they are returned in order
                let orders = []
                if (results[0].status === 'fulfilled') {
                    let commercialProjects = results[0].value.Projects
                    commercialProjects.forEach((project) => {
                        project.isCommercial = true
                    })

                    orders = commercialProjects
                } else {
                    alert('There was an issue loading commercial projects')
                }

                if (results[1].status === 'fulfilled') {
                    let residentialProjects = results[1].value.Projects
                    residentialProjects.forEach((project) => {
                        project.isCommercial = false
                    })

                    orders = orders.concat(residentialProjects)
                } else {
                    alert('There was an issue loading residential projects')
                }

                this.setState({
                    isLoadingOrders: false,
                    isLandingPage: (orders.length === 0 && isLandingPage == null) ? true : false,
                    orders: orders
                }, () => {
                    this.setSorting('ItemModifiedWhen', false)
                })
            })
    }

    createNewProject = (event) => {
        event.preventDefault()

        this.setState({ hasSubmittedNewProject: true })

        if (this.state.nameNewProject !== '' && validateProjectOrBoardName(this.state.nameNewProject)) {
            this.setState({
                newProjectErrorMessage: '',
                isLoadingNewProject: true
            })

            let apiCall = apiCallsCommercial
            if (this.state.selectedProjectTypeForCreation === 'Residential') apiCall = apiCallsResidential

            // Seems like we need to call API to get a project with ID 0 to retrieve the response to pass to "Save project" API with new title
            // After that we will have a new project with real ID
            apiCall.apiGetProject(this.props.projectId)
                .then(projectData => {
                    projectData.Title = this.state.nameNewProject

                    apiCall.apiSetProjectTitle(projectData)
                        .then(response => {
                            // At this point we can read ItemGUID from the response and redirect user to that page
                            this.setState({
                                hasCreatedNewProject: true
                            }, () => {
                                commonFunctionsService.closeModals()
                                this.GA4DataLayerForProject('create project', response)

                                window.setTimeout(() => {
                                    // After a small timout which will display a custom full screen message, redirect the user to the project details
                                    this.openProject(response.ItemID, this.state.selectedProjectTypeForCreation === 'Commercial')
                                }, 2500)
                            })
                        })
                        .catch(error => {
                            this.setState({
                                newProjectErrorMessage: error,
                                isLoadingNewProject: false
                            })
                        })
                })

        } else {
            this.setState({ newProjectErrorMessage: 'Invalid project name. Only letters, numbers, "-", and spaces are allowed.' })
        }
    }

    startCreatingNewProject = () => {
        this.setState({ selectedProjectTypeForCreation: this.state.currentFlexType, isCreatingNewProject: true })
    }

    stopCreatingNewProject = () => {
        this.setState({ isCreatingNewProject: false })

        commonFunctionsService.closeModals()
    }

    handelChange = (name, value) => {
        this.setState({ ['' + name]: value }, () => {
            if (validateProjectOrBoardName(this.state.nameNewProject)) {
                this.setState({ newProjectErrorMessage: '' })
            } else {
                this.setState({ newProjectErrorMessage: 'Invalid project name. Only letters, numbers, "-", and spaces are allowed.' })
            }
        })
    }

    startProjectDeletion = (projectID) => {
        this.setState({
            confirmingProjectDeletion: true,
            projectToDelete: projectID
        })
    }

    stopProjectDeletion = () => {
        this.setState({
            confirmingProjectDeletion: false,
            projectToDelete: 0
        })

        commonFunctionsService.closeModals()
    }

    deleteProject = () => {
        const project = this.getProject(this.state.projectToDelete)
        this.setState({ isDeletingProject: true })

        let requestObj = {
            'IsArchived': false,
            'IsDeleted': false,
            'ProjectID': this.state.projectToDelete
        }

        if (project.IsFinalised) { // 'complete'
            requestObj = {
                ...requestObj,
                'IsDeleted': true
            }
        } else {
            requestObj = {
                ...requestObj,
                'IsArchived': true
            }
        }

        this.GA4DataLayerForProject('delete project', project)

        this.setState({
            deletingProjectTitle: 'Deleting project',
            deletedProjectMessage: 'Project successfully deleted'
        })

        this.stopProjectDeletion()

        let apiCall = apiCallsCommercial
        if (this.state.currentFlexType === 'Residential') apiCall = apiCallsResidential

        apiCall.apiArchiveDeleteProject(requestObj)
            .then((serverResponse) => {

                this.setState({
                    isDeletingProject: false,
                    hasDeletedProject: true,
                    projectToDelete: 0
                }, () => {
                    this.updateOrders(serverResponse.Projects, this.state.currentFlexType)
                    this.updateProjectStats()
                })

                setTimeout(() => this.setState({ hasDeletedProject: false }), 3000)
            })
            .catch(error => {
                this.setState({
                    isDeletingProject: false,
                    pageError: `Something went wrong: ${error.message}`
                })
            })
    }

    updateOrders = (orders, flexType) => {
        let updatedOrders = cloneDeep(this.state.orders)
        updatedOrders = updatedOrders.filter((order) => {
            return (order.isCommercial && flexType === 'Residential') || (!order.isCommercial && flexType === 'Commercial')
        })

        // At this point we have orders only from other type to which we are going to add updated orders of the type of interest
        orders.forEach(order => order.isCommercial = flexType === 'Commercial') // Update the project type
        updatedOrders = updatedOrders.concat(orders)
        this.setState({ orders: updatedOrders }, () => this.setSorting('ItemModifiedWhen', false))
    }

    getProject = (projectID) => {
        return this.state.orders.find((order) => order.ItemID === projectID)
    }

    duplicateProject = projectID => {
        const project = this.getProject(projectID)
        this.setState({ isDuplicatingProject: true })

        let requestObj = { "ProjectID": projectID }

        if (project.IsFinalised) { // 'complete'
            requestObj = {
                ...requestObj,
                "IsArchived": true
            }
        }

        let apiCall = apiCallsCommercial
        if (this.state.currentFlexType === 'Residential') apiCall = apiCallsResidential

        apiCall.apiCopyProject(requestObj)
            .then(serverResponse => {
                this.setState({
                    isDuplicatingProject: false,
                    hasDuplicatedProject: true
                }, () => {
                    this.updateOrders(serverResponse.Projects, this.state.currentFlexType)
                    this.updateProjectStats()
                })
                const duplicatedProject = serverResponse.Projects[serverResponse.Projects.length - 1]
                this.GA4DataLayerForProject("duplicate project", duplicatedProject)
                setTimeout(() => this.setState({ hasDuplicatedProject: false }), 3000)
            })
            .catch(error => {
                this.setState({
                    isDuplicatingProject: false,
                    pageError: `Something went wrong: ${error.message}`
                })
            })
    }

    calculateAnyFilteringResults = () => {
        var anySearchResults = true
        const anyProjectsOfCurrentType = this.state.orders.some(order => {
            return (this.state.isCommercial && order.isCommercial) || (!this.state.isCommercial && !order.isCommercial)
        })

        if (!anyProjectsOfCurrentType) {
            anySearchResults = false
        } else {
            anySearchResults = this.state.orders.some(order => {
                if (this.state.filterProjectTypeValue !== 'all') {
                    if (this.state.filterProjectTypeValue === 'incomplete') {
                        if (this.state.searchValue !== '') {
                            return !order.IsFinalised && order.Title.toLowerCase().indexOf(this.state.searchValue.toLowerCase()) > -1 && ((this.state.isCommercial && order.isCommercial) || (!this.state.isCommercial && !order.isCommercial))
                        } else {
                            return !order.IsFinalised
                        }
                    }

                    if (this.state.filterProjectTypeValue === 'complete') {
                        if (this.state.searchValue !== '') {
                            return order.IsFinalised && order.Title.toLowerCase().indexOf(this.state.searchValue.toLowerCase()) > -1 && ((this.state.isCommercial && order.isCommercial) || (!this.state.isCommercial && !order.isCommercial))
                        } else {
                            return order.IsFinalised
                        }
                    }
                } else if (this.state.searchValue !== '') {
                    return order.Title.toLowerCase().indexOf(this.state.searchValue.toLowerCase()) > -1 && ((this.state.isCommercial && order.isCommercial) || (!this.state.isCommercial && !order.isCommercial))
                }

                return true
            })
        }

        this.setState({ anySearchResults: anySearchResults })
    }

    handleChange = (event) => {
        this.setState({
            searchValue: event.target.value
        }, () => {
            this.calculateAnyFilteringResults()
        })
    }

    filterProjectType = (projectType) => {
        this.setState({
            filterProjectTypeValue: projectType
        }, () => {
            this.calculateAnyFilteringResults()
        })
    }

    compareByProperty = (a, b, propertyName, reverse) => {
        if (reverse) {
            if (a[propertyName] < b[propertyName]) return -1
            if (a[propertyName] > b[propertyName]) return 1
        } else {
            if (a[propertyName] > b[propertyName]) return -1
            if (a[propertyName] < b[propertyName]) return 1
        }

        return 0
    }

    compareByDate = (a, b, propertyName, reverse) => {
        var aV = a[propertyName].split('/').reverse().join('/')
        var bV = b[propertyName].split('/').reverse().join('/')

        if (reverse) {
            if (aV < bV) return -1
            if (aV > bV) return 1
        } else {
            if (aV > bV) return -1
            if (aV < bV) return 1
        }
    }

    setSorting = (sorthingType, sortingOrder) => {
        var sortingDirection = ''
        if (sortingOrder !== undefined) {
            sortingDirection = sortingOrder
        } else {
            sortingDirection = !this.state.ascendingSorting
        }

        this.setState({
            sorthingType: sorthingType,
            ascendingSorting: sortingDirection
        })

        if (this.state.ascendingSorting) {
            if (sorthingType === 'ItemModifiedWhen') {
                this.state.orders.sort((a, b) => this.compareByDate(a, b, sorthingType, true))
            } else {
                this.state.orders.sort((a, b) => this.compareByProperty(a, b, sorthingType, true))
            }
        } else {
            if (sorthingType === 'ItemModifiedWhen') {
                this.state.orders.sort((a, b) => this.compareByDate(a, b, sorthingType, false))
            } else {
                this.state.orders.sort((a, b) => this.compareByProperty(a, b, sorthingType, false))
            }
        }
    }

    openProject = (projectID, isCommercial, event) => {
        // Open the project only if the user is not clicking on the duplicate or delete button
        if (event !== undefined &&
            jQuery(event.target).closest('button.duplicate').length === 0 &&
            jQuery(event.target).closest('button.delete').length === 0) {

            if (isCommercial) {
                this.props.history.push(CONST.PAGES.PROJECT_DETAILS + '?orderID=' + projectID)
            } else {
                this.props.history.push(CONST.PAGES.PROJECT_DETAILS_RESIDENTIAL + '?orderID=' + projectID)
            }
        } else if (event === undefined) {
            if (isCommercial) {
                this.props.history.push(CONST.PAGES.PROJECT_DETAILS + '?orderID=' + projectID)
            } else {
                this.props.history.push(CONST.PAGES.PROJECT_DETAILS_RESIDENTIAL + '?orderID=' + projectID)
            }
        }
    }

    hideLandingPage = () => {
        window.localStorage.setItem('isLandingPage', false)

        this.setState({
            isLandingPage: false
        })
    }

    hidePopup = () => {
        this.setState({ landingPopupMessage: ''})
    }

    openHowItWorksModal = () => {
        this.setState({
            howItWorksModal: !this.state.howItWorksModal
        })
    }

    GA4DataLayerForProject = (type, project) => {
        const isCommercial = this.state.currentFlexType === 'Commercial'
        const dataLayerObject = {
            "project_type": isCommercial ? 'Commercial' : 'Residential',
            "project_name": project.Title,
            "project_id": project.ItemID.toString() 
        }
        if (type === 'create project') {
            analyticsDataLayer.createProject(dataLayerObject)
        } else if (type === 'duplicate project') {
            analyticsDataLayer.duplicateProject(dataLayerObject)
        } else if (type === 'delete project') {
            analyticsDataLayer.deleteProject(dataLayerObject)
        }
    }

    render() {
        if (this.state.isLoading) {
            return <GlobalLoader />
        } else {
            return (
                <div className="app">
                    {
                        this.state.landingPopupMessage !== '' &&
                        <Modal
                            modalID="landing-popup-message"
                            modalClassName="landing-popup-message"
                            modalTitle="Notice"
                            callback={this.hidePopup}>

                            <div>{this.state.landingPopupMessage}</div>

                        </Modal>
                    }

                    {
                        this.state.isCreatingNewProject &&
                        <Modal
                            modalID="new-project-modal"
                            modalClassName="new-project-modal modal--sm"
                            modalTitle="New Project"
                            callback={this.stopCreatingNewProject}>

                            <form className="form" onSubmit={this.createNewProject}>
                                <div className={"form__group " + (this.state.hasSubmittedNewProject && (this.state.nameNewProject === '' || !validateProjectOrBoardName(this.state.nameNewProject)) ? 'is-invalid' : '')}>
                                    <label className="form__label">Project name</label>
                                    <input className="form__input input" type="text" name="nameNewProject" value={this.state.nameNewProject}
                                        onChange={(event) => this.handelChange(event.target.name, event.target.value)} required maxLength="128" autoFocus></input>
                                </div>
                                {
                                    !this.state.isSwitchBoardManufacturerOrLargeContractor &&
                                    <div className="row">
                                        <div className="col-6">
                                            <RadioObjectGroup
                                                title="Project Type"
                                                options={[{
                                                    "value": "Commercial",
                                                    "label": "Commercial",
                                                    "warning": "",
                                                    "enabled": true
                                                }, {
                                                    "value": "Residential",
                                                    "label": "Residential",
                                                    "warning": "",
                                                    "enabled": true
                                                }]}
                                                selectedValue={(this.state.selectedProjectTypeForCreation)}
                                                selecteCallback={value => this.setState({ selectedProjectTypeForCreation: value })}
                                            />
                                        </div>
                                    </div>
                                }

                                {
                                    this.state.newProjectErrorMessage &&
                                    <div className="modal__validation-msg">
                                        <span className="alert__icon">
                                            <span className="i-exclamation"></span>
                                        </span>
                                        <span dangerouslySetInnerHTML={{ __html: this.state.newProjectErrorMessage }}></span>
                                    </div>
                                }

                                <div className="form__actions">
                                    <button className="button button--text" type="button" onClick={this.stopCreatingNewProject}>
                                        <span className="button__text">Cancel</span>
                                    </button>
                                    <button type="submit" className={"button button--1 " + (this.state.isLoadingNewProject ? 'disabled' : '')} disabled={this.state.isLoadingNewProject}>
                                        <span className="button__text">
                                            Create Project
                                        </span>
                                    </button>
                                </div>
                            </form>

                        </Modal>
                    }


                    {
                        this.state.confirmingProjectDeletion &&
                        <Modal
                            modalClassName="modal--sm"
                            modalTitle="Confirm Project Deletion"
                            callback={this.stopProjectDeletion}>

                            <p>Are you sure you want to delete this project?</p>

                            <div className="form__actions">
                                <button className="button button--text" onClick={this.stopProjectDeletion}>
                                    <span className="button__text">Cancel</span>
                                </button>
                                <button type="button" className="button button--1 " onClick={this.deleteProject}>
                                    <span className="button__text">
                                        Yes, Delete
                                    </span>
                                </button>
                            </div>
                        </Modal>
                    }

                    {this.state.howItWorksModal &&
                        <Modal
                            modalID="new-project-modal"
                            modalClassName="new-project-modal modal--sm"
                            callback={this.openHowItWorksModal}
                            modalTitle="How it works" >
                            {this.state.isCommercial ?
                                <iframe width="100%" height="315" src="https://www.youtube.com/embed/7ZOm99ud7y8?modestbranding=1&autohide=1&showinfo=0&controls=1&rel=0" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen></iframe>
                                :
                                <iframe width="100%" height="315" src="https://www.youtube.com/embed/FJjpmr_3PUQ?modestbranding=1&autohide=1&showinfo=0&controls=1&rel=0" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen></iframe>
                            }
                        </Modal>
                    }

                    {
                        this.state.hasCreatedNewProject &&
                        <GlobalOverlay>
                            <div>
                                <div className="globalOverlay__message">
                                    <span className="globalOverlay__message-success-icon">
                                        <span className="i-check"></span>
                                    </span>
                                    <span className="h3">Project Created</span>
                                </div>
                            </div>
                        </GlobalOverlay>
                    }

                    {
                        this.state.isDuplicatingProject &&
                        <GlobalOverlay>
                            <div>
                                <div className="globalOverlay__message">
                                    <span className="globalOverlay__message-spinner">
                                        <span className="spinner"></span>
                                    </span>
                                    <span className="h3">Duplicating Project</span>
                                </div>
                            </div>
                        </GlobalOverlay>
                    }

                    {
                        this.state.hasDuplicatedProject &&
                        <GlobalOverlay>
                            <div>
                                <div className="globalOverlay__message">
                                    <span className="globalOverlay__message-success-icon">
                                        <span className="i-check"></span>
                                    </span>
                                    <span className="h3">Project successfully copied</span>
                                </div>
                            </div>
                        </GlobalOverlay>
                    }

                    {
                        this.state.isDeletingProject &&
                        <GlobalOverlay>
                            <div>
                                <div className="globalOverlay__message">
                                    <span className="globalOverlay__message-spinner">
                                        <span className="spinner"></span>
                                    </span>
                                    <span className="h3">{this.state.deletingProjectTitle}</span>
                                </div>
                            </div>
                        </GlobalOverlay>
                    }

                    {
                        this.state.hasDeletedProject &&
                        <GlobalOverlay>
                            <div>
                                <div className="globalOverlay__message">
                                    <span className="globalOverlay__message-success-icon">
                                        <span className="i-check"></span>
                                    </span>
                                    <span className="h3">{this.state.deletedProjectMessage}</span>
                                </div>
                            </div>
                        </GlobalOverlay>
                    }

                    <Header isCommercial={this.state.isCommercial}>
                        <div className="header__section hs_project-start">
                            <h2 className="h2 header__title">
                                <span>
                                    My {this.state.isCommercial && !this.state.isSwitchBoardManufacturerOrLargeContractor && <span>Commercial</span>}{!this.state.isCommercial && <span>Residential</span>} Projects
                                </span>
                                {
                                    !this.state.isSwitchBoardManufacturerOrLargeContractor &&
                                    <label className="config-switch">
                                        <input type="checkbox" className="switch__input" checked={!this.state.isCommercial}
                                            onChange={(e) => {
                                                this.setState({ isCommercial: !this.state.isCommercial, currentFlexType: e.target.checked ? 'Residential' : 'Commercial' }, () => this.calculateAnyFilteringResults())
                                            }} />

                                        <div className="switch__button switch__button--on">
                                            <span className="switch__button-icon">
                                                <span className="i-commercial"></span>
                                            </span>
                                            <span className="switch__button-text">Commercial</span>
                                        </div>
                                        <span className="switch__slider slider round"></span>
                                        <div className="switch__button switch__button--off">
                                            <span className="switch__button-icon">
                                                <span className="i-home"></span>
                                            </span>
                                            <span className="switch__button-text">Residential</span>
                                        </div>
                                    </label>
                                }
                            </h2>

                            <div className="header__actions">
                                <div className="header__search" action="">
                                    <input className="header__search-input input" type="search" placeholder="Search by Project"
                                        value={this.state.searchValue} onChange={this.handleChange} />
                                    <span className="header__search-button button button--icon">
                                        <span className="button__icon">
                                            <span className="i-search"></span>
                                        </span>
                                    </span>
                                </div>
                                <button className="button button--1" onClick={this.startCreatingNewProject}>
                                    <span className="button__icon">
                                        <span className="i-plus"></span>
                                    </span>
                                    <span className="button__text">
                                        New Project
                                    </span>
                                </button>
                            </div>
                        </div>

                        <div className="header__section hs_tabs">
                            <div className="tabs">
                                <div className={'tab' + (this.state.filterProjectTypeValue === 'all' ? ' is-active' : '')}
                                    onClick={() => { this.filterProjectType('all') }}>
                                    <div className="tab__count">{this.state['incompleteCount' + this.state.currentFlexType] + this.state['completeCount' + this.state.currentFlexType] + this.state['toBeApprovedCount' + this.state.currentFlexType]}</div>
                                    <div className="tab__text">All Projects</div>
                                </div>
                                <div className={'tab' + (this.state.filterProjectTypeValue === 'incomplete' ? ' is-active' : '')}
                                    onClick={() => { this.filterProjectType('incomplete') }}>
                                    <div className="tab__count">{this.state['incompleteCount' + this.state.currentFlexType] + this.state['toBeApprovedCount' + this.state.currentFlexType]}</div>
                                    <div className="tab__text">In Progress</div>
                                </div>
                                <div className={'tab' + (this.state.filterProjectTypeValue === 'complete' ? ' is-active' : '')}
                                    onClick={() => { this.filterProjectType('complete') }}>
                                    <div className="tab__count">{this.state['completeCount' + this.state.currentFlexType]}</div>
                                    <div className="tab__text">Completed Orders</div>
                                </div>
                            </div>
                        </div>
                    </Header>

                    <div className="app__body">
                        <div className="app__body-content">
                            {
                                (!this.state.isLoadingOrders && this.state.orders.length === 0 && !this.state.isLandingPage ||
                                    (!this.state.isLandingPage && this.state['incompleteCount' + this.state.currentFlexType] === 0 &&
                                        this.state['toBeApprovedCount' + this.state.currentFlexType] === 0)) &&
                                this.state.filterProjectTypeValue !== 'complete' &&
                                <div className="board-message-mute">
                                    <svg width="54" height="54" viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M50.5504 47.2001L50.6748 47.1995V47.0751V25.9337V25.8087H50.5498H35.0639H34.9389V25.9337V31.5346C34.9389 31.8628 34.8346 32.1717 34.66 32.4298L34.7579 32.4961L34.66 32.4299C34.3678 32.8621 33.8841 33.1451 33.3789 33.1451H20.6211C20.1172 33.1451 19.6372 32.8615 19.3444 32.4297L19.3437 32.4288C19.1656 32.1712 19.0611 31.8627 19.0611 31.5346V25.9337V25.8087H18.9361H3.45022H3.32522V25.9337V47.0751V47.1995L3.44961 47.2001L26.9994 47.3157L27.0006 47.3157L50.5504 47.2001ZM13.8009 7.75721H13.9259V7.63221V5.34452H13.9261L13.9257 5.33726C13.7692 2.64475 15.8827 0.260969 18.6187 0.184115L18.6368 0.183605L18.6541 0.177948C18.8768 0.104964 19.0008 0.111939 19.1217 0.171343L19.1478 0.184164H19.1768H34.8232H34.8522L34.8783 0.171343C34.9992 0.111939 35.1232 0.104964 35.3459 0.177948L35.3632 0.183605L35.3813 0.184115C38.1173 0.260969 40.2308 2.64475 40.0743 5.33726L40.0741 5.33725V5.34452V7.63221V7.75721H40.1991H50.3893C52.3246 7.75721 53.875 9.35627 53.875 11.261V47.0751C53.875 47.783 53.6609 48.4372 53.2887 48.9805L53.2687 49.0096L53.267 49.0449C53.2254 49.8783 52.504 50.5 51.7088 50.5H2.29123C1.496 50.5 0.774601 49.8783 0.733036 49.0449L0.731276 49.0096L0.711316 48.9805C0.339143 48.4372 0.125 47.783 0.125 47.0751V11.261C0.125 9.28095 1.75202 7.75721 3.6107 7.75721H13.8009ZM17.3668 7.47444V7.59944H17.4918H36.5082H36.6332V7.47444V5.10786C36.6332 4.09786 35.8606 3.24737 34.8232 3.24737H19.1768C18.1394 3.24737 17.3668 4.09786 17.3668 5.10786V7.47444ZM3.68529 11.1343L3.56349 11.1349L3.56095 11.2567L3.32525 22.539L3.32258 22.6666H3.45022H19.9792H20.0083L20.0343 22.6538C20.1832 22.5807 20.4048 22.5089 20.6211 22.5089H33.3789C33.5952 22.5089 33.8168 22.5807 33.9657 22.6538L33.9917 22.6666H34.0208H50.5498H50.6774L50.6747 22.539L50.439 11.2567L50.4365 11.1349L50.3147 11.1343L27.0006 11.0171L26.9994 11.0171L3.68529 11.1343ZM22.2613 29.878V30.003H22.3863H31.6137H31.7387V29.878V25.9337V25.8087H31.6137H22.3863H22.2613V25.9337V29.878Z" fill="#CBCBCB" stroke="white" strokeWidth="0.25" />
                                    </svg>
                                    <p>
                                        You don’t have any {this.state.isCommercial && <span>Commercial</span>}{!this.state.isCommercial && <span>Residential</span>} projects yet.
                                    </p>
                                    <p>
                                        Add your first project above
                                    </p>
                                </div>
                            }

                            {this.state.isLandingPage &&
                                <>
                                    <div className='board-landing-page'>
                                        <div className='board-landing-page__title'>
                                            Welcome to FlexSelect
                                        </div>

                                        <div className="board-landing-page__close-icon" onClick={this.hideLandingPage}>
                                            <span className="i-close"></span>
                                        </div>

                                        <div style={{ display: "flex", justifyContent: "space-between", gap: "10%" }}>
                                            <div onClick={() => this.openHowItWorksModal()}>
                                                <div className='board-landing-page__landing-image'>
                                                </div>
                                                <div className='board-landing-page__how-it-works'>
                                                    <div>
                                                        <svg width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <circle cx="16.5" cy="16.5" r="16.5" fill="#3CC856" />
                                                            <path d="M25 17L13 23.9282L13 10.0718L25 17Z" fill="white" />
                                                        </svg>
                                                    </div>
                                                    <div>
                                                        See how it works
                                                    </div>
                                                </div>
                                            </div>
                                            <div>
                                                <div className='board-landing-page__cards board-landing-page__new-project' onClick={this.startCreatingNewProject}>
                                                    <div>
                                                        <span className="i-document"></span>
                                                    </div>
                                                    <div>
                                                        <div className='board-landing-page__cards__title'>
                                                            Start with a project
                                                        </div>
                                                        <div className='board-landing-page__cards__sub-title'>
                                                            Creating a project allows you to configure your board(s)
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className='board-landing-page__cards'>
                                                    <div className=''>
                                                        <span className="i-switchboard"></span>
                                                    </div>
                                                    <div className=''>
                                                        <div className='board-landing-page__cards__title'>
                                                            Add a board and components
                                                        </div>
                                                        <div className='board-landing-page__cards__sub-title'>
                                                            Create a board for your project and configure the components you need
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className='board-landing-page__cards'>
                                                    <div className=''>
                                                        <span className="i-check"></span>
                                                    </div>
                                                    <div className=''>
                                                        <div className='board-landing-page__cards__title'>
                                                            Get your boards
                                                        </div>
                                                        <div className='board-landing-page__cards__sub-title'>
                                                            Once your board is configured you are ready to get a quote, place the order and receive the board.
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </>
                            }

                            {
                                this.state.orders.length > 0 && !this.state.anySearchResults && this.state.searchValue !== '' &&
                                <div className="board-message-mute">
                                    <svg width="54" height="54" viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M50.5504 47.2001L50.6748 47.1995V47.0751V25.9337V25.8087H50.5498H35.0639H34.9389V25.9337V31.5346C34.9389 31.8628 34.8346 32.1717 34.66 32.4298L34.7579 32.4961L34.66 32.4299C34.3678 32.8621 33.8841 33.1451 33.3789 33.1451H20.6211C20.1172 33.1451 19.6372 32.8615 19.3444 32.4297L19.3437 32.4288C19.1656 32.1712 19.0611 31.8627 19.0611 31.5346V25.9337V25.8087H18.9361H3.45022H3.32522V25.9337V47.0751V47.1995L3.44961 47.2001L26.9994 47.3157L27.0006 47.3157L50.5504 47.2001ZM13.8009 7.75721H13.9259V7.63221V5.34452H13.9261L13.9257 5.33726C13.7692 2.64475 15.8827 0.260969 18.6187 0.184115L18.6368 0.183605L18.6541 0.177948C18.8768 0.104964 19.0008 0.111939 19.1217 0.171343L19.1478 0.184164H19.1768H34.8232H34.8522L34.8783 0.171343C34.9992 0.111939 35.1232 0.104964 35.3459 0.177948L35.3632 0.183605L35.3813 0.184115C38.1173 0.260969 40.2308 2.64475 40.0743 5.33726L40.0741 5.33725V5.34452V7.63221V7.75721H40.1991H50.3893C52.3246 7.75721 53.875 9.35627 53.875 11.261V47.0751C53.875 47.783 53.6609 48.4372 53.2887 48.9805L53.2687 49.0096L53.267 49.0449C53.2254 49.8783 52.504 50.5 51.7088 50.5H2.29123C1.496 50.5 0.774601 49.8783 0.733036 49.0449L0.731276 49.0096L0.711316 48.9805C0.339143 48.4372 0.125 47.783 0.125 47.0751V11.261C0.125 9.28095 1.75202 7.75721 3.6107 7.75721H13.8009ZM17.3668 7.47444V7.59944H17.4918H36.5082H36.6332V7.47444V5.10786C36.6332 4.09786 35.8606 3.24737 34.8232 3.24737H19.1768C18.1394 3.24737 17.3668 4.09786 17.3668 5.10786V7.47444ZM3.68529 11.1343L3.56349 11.1349L3.56095 11.2567L3.32525 22.539L3.32258 22.6666H3.45022H19.9792H20.0083L20.0343 22.6538C20.1832 22.5807 20.4048 22.5089 20.6211 22.5089H33.3789C33.5952 22.5089 33.8168 22.5807 33.9657 22.6538L33.9917 22.6666H34.0208H50.5498H50.6774L50.6747 22.539L50.439 11.2567L50.4365 11.1349L50.3147 11.1343L27.0006 11.0171L26.9994 11.0171L3.68529 11.1343ZM22.2613 29.878V30.003H22.3863H31.6137H31.7387V29.878V25.9337V25.8087H31.6137H22.3863H22.2613V25.9337V29.878Z" fill="#CBCBCB" stroke="white" strokeWidth="0.25" />
                                    </svg>
                                    <p>
                                        No projects found
                                    </p>
                                </div>
                            }

                            {
                                !this.state.isLoadingOrders && this.state.orders.length > 0 && !this.state.isLandingPage &&
                                <div>
                                    {
                                        (
                                            (this.state.anySearchResults && this.state.filterProjectTypeValue !== 'complete') ||
                                            (
                                                this.state.anySearchResults &&
                                                this.state.filterProjectTypeValue === 'complete' &&
                                                this.state['completeCount' + this.state.currentFlexType] > 0
                                            )
                                        ) &&
                                        (
                                            this.state['incompleteCount' + this.state.currentFlexType] > 0 ||
                                            this.state['toBeApprovedCount' + this.state.currentFlexType] > 0
                                        ) &&
                                        <div className="projects-header">
                                            <div className="l_project-row">
                                                <div className={' sort-button name' + (this.state.sorthingType === 'Title' ? ' is-active' : '') +
                                                    (!this.state.ascendingSorting ? ' ascending' : ' descending')}
                                                    onClick={() => { this.setSorting('Title') }}>
                                                    Project Name
                                                    <span className="i-sorting"></span>
                                                </div>
                                                <div className={' sort-button job-number' + (this.state.sorthingType === 'ProjectNumberReadOnly' ? ' is-active' : '') +
                                                    (!this.state.ascendingSorting ? ' ascending' : ' descending')}
                                                    onClick={() => { this.setSorting('ProjectNumberReadOnly') }}>
                                                    Job Number
                                                    <span className="i-sorting"></span>
                                                </div>
                                                <div className={' sort-button last-edited' + (this.state.sorthingType === 'ItemModifiedWhen' ? ' is-active' : '') +
                                                    (!this.state.ascendingSorting ? ' ascending' : ' descending')}
                                                    onClick={() => { this.setSorting('ItemModifiedWhen') }}>
                                                    Last Edited
                                                    <span className="i-sorting"></span>
                                                </div>
                                                <div className={' sort-button status' + (this.state.sorthingType === 'IsFinalised' ? ' is-active' : '') +
                                                    (!this.state.ascendingSorting ? ' ascending' : ' descending')}
                                                    onClick={() => { this.setSorting('IsFinalised') }}>
                                                    Status
                                                    <span className="i-sorting"></span>
                                                </div>
                                                <div className="actions"></div>
                                            </div>
                                        </div>
                                    }

                                    <div className="projects-list">
                                        {
                                            !this.state.isLoadingOrders && this.state['completeCount' + this.state.currentFlexType] === 0 && this.state.filterProjectTypeValue === 'complete' &&
                                            <div className="board-message-mute">
                                                <svg width="54" height="54" viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M50.5504 47.2001L50.6748 47.1995V47.0751V25.9337V25.8087H50.5498H35.0639H34.9389V25.9337V31.5346C34.9389 31.8628 34.8346 32.1717 34.66 32.4298L34.7579 32.4961L34.66 32.4299C34.3678 32.8621 33.8841 33.1451 33.3789 33.1451H20.6211C20.1172 33.1451 19.6372 32.8615 19.3444 32.4297L19.3437 32.4288C19.1656 32.1712 19.0611 31.8627 19.0611 31.5346V25.9337V25.8087H18.9361H3.45022H3.32522V25.9337V47.0751V47.1995L3.44961 47.2001L26.9994 47.3157L27.0006 47.3157L50.5504 47.2001ZM13.8009 7.75721H13.9259V7.63221V5.34452H13.9261L13.9257 5.33726C13.7692 2.64475 15.8827 0.260969 18.6187 0.184115L18.6368 0.183605L18.6541 0.177948C18.8768 0.104964 19.0008 0.111939 19.1217 0.171343L19.1478 0.184164H19.1768H34.8232H34.8522L34.8783 0.171343C34.9992 0.111939 35.1232 0.104964 35.3459 0.177948L35.3632 0.183605L35.3813 0.184115C38.1173 0.260969 40.2308 2.64475 40.0743 5.33726L40.0741 5.33725V5.34452V7.63221V7.75721H40.1991H50.3893C52.3246 7.75721 53.875 9.35627 53.875 11.261V47.0751C53.875 47.783 53.6609 48.4372 53.2887 48.9805L53.2687 49.0096L53.267 49.0449C53.2254 49.8783 52.504 50.5 51.7088 50.5H2.29123C1.496 50.5 0.774601 49.8783 0.733036 49.0449L0.731276 49.0096L0.711316 48.9805C0.339143 48.4372 0.125 47.783 0.125 47.0751V11.261C0.125 9.28095 1.75202 7.75721 3.6107 7.75721H13.8009ZM17.3668 7.47444V7.59944H17.4918H36.5082H36.6332V7.47444V5.10786C36.6332 4.09786 35.8606 3.24737 34.8232 3.24737H19.1768C18.1394 3.24737 17.3668 4.09786 17.3668 5.10786V7.47444ZM3.68529 11.1343L3.56349 11.1349L3.56095 11.2567L3.32525 22.539L3.32258 22.6666H3.45022H19.9792H20.0083L20.0343 22.6538C20.1832 22.5807 20.4048 22.5089 20.6211 22.5089H33.3789C33.5952 22.5089 33.8168 22.5807 33.9657 22.6538L33.9917 22.6666H34.0208H50.5498H50.6774L50.6747 22.539L50.439 11.2567L50.4365 11.1349L50.3147 11.1343L27.0006 11.0171L26.9994 11.0171L3.68529 11.1343ZM22.2613 29.878V30.003H22.3863H31.6137H31.7387V29.878V25.9337V25.8087H31.6137H22.3863H22.2613V25.9337V29.878Z" fill="#CBCBCB" stroke="white" strokeWidth="0.25" />
                                                </svg>
                                                <p>
                                                    You don’t have any completed {this.state.isCommercial && <span>Commercial</span>}{!this.state.isCommercial && <span>Residential</span>} projects yet.
                                                </p>
                                            </div>
                                        }

                                        {
                                            this.state.orders.map((order, index) => {
                                                if ((this.state.searchValue !== '' && order.Title.toLowerCase().indexOf(this.state.searchValue.toLowerCase()) === -1) || (this.state.isCommercial && !order.isCommercial) || (!this.state.isCommercial && order.isCommercial)) {
                                                    return ''
                                                } else {
                                                    return (
                                                        <React.Fragment key={index}>
                                                            {
                                                                (
                                                                    (this.state.filterProjectTypeValue === 'all') ||
                                                                    (this.state.filterProjectTypeValue === 'incomplete' && !order.IsFinalised) ||
                                                                    (this.state.filterProjectTypeValue === 'complete' && order.IsFinalised)
                                                                )
                                                                &&
                                                                <div className={'project l_project-row' +
                                                                    (order.IsToBeApproved ? ' is-available' : '') +
                                                                    (!order.IsFinalised ? ' is-in-progress' : '') +
                                                                    (order.IsFinalised ? ' is-complete' : '')
                                                                } onClick={(event) => { this.openProject(order.ItemID, order.isCommercial, event) }}>
                                                                    <div className="project-col name h5">{order.Title}</div>
                                                                    <div className="project-col job-number">{order.ProjectNumberReadOnly}</div>
                                                                    <div className="project-col last-edited">{order.ItemModifiedWhen}</div>
                                                                    <div className="project-col status">
                                                                        <span className={'tag' + (order.IsFinalised ? ' tag--1' : ' tag--2')}>
                                                                            {order.IsToBeApproved && 'Available'}
                                                                            {!order.IsFinalised && 'In Progress'}
                                                                            {order.IsFinalised && 'Order Completed'}
                                                                        </span>
                                                                    </div>

                                                                    <div className="project-col actions">
                                                                        <button className="button button-3 duplicate" onClick={() => { this.duplicateProject(order.ItemID) }} >
                                                                            <span className="button__icon">
                                                                                <span className="i-duplicate"></span>
                                                                            </span>
                                                                            <span className="button__text">
                                                                                Duplicate
                                                                            </span>
                                                                        </button>
                                                                        <button className="button button-3 delete" onClick={() => { this.startProjectDeletion(order.ItemID) }}>
                                                                            <span className="button__icon">
                                                                                <span className="i-trash-bin"></span>
                                                                            </span>
                                                                            <span className="button__text">
                                                                                Delete
                                                                            </span>
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            }
                                                        </React.Fragment>
                                                    )
                                                }
                                            })
                                        }
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            )
        }
    }
}

export default withRouter(Projects)
